import React from 'react'
import FileUpload from './FileUpload'
import FileUploadSave from './FileUploadSave'
import { useState } from 'react'

const FileUploadForm = ({ tableOwnerId, tableOwnerType, type, setOpen }) => {

    const [files, setFiles] = useState([])

  return (
    <div>
        <FileUpload
            setFilesExt={setFiles}
        />

        {/* <SupplierFileUploadSave  */}
        <FileUploadSave
            files={files}
            tableOwnerId={tableOwnerId}
            tableOwnerType={tableOwnerType}
            type={type}
            setOpen={setOpen}
        />
    </div>
  )
}

export default FileUploadForm